module.exports = __webpack_public_path__ + "img/empty.ad392c68.png";